import script from "./AuthTitleBtn.component.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthTitleBtn.component.vue?vue&type=script&setup=true&lang=js"

import "./AuthTitleBtn.component.vue?vue&type=style&index=0&id=2ccd58cd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ccd58cd"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
